import {
  TabView as BaseTabView,
  TabDefinition,
} from '@features/campaigns/components/TabView';
import { SummaryContainer } from './Summary/SummaryContainer';
import { RealTimeOptimizationContainer } from './RealTimeOptimization/RealTimeOptimizationContainer';

const tabs: TabDefinition[] = [
  {
    label: 'Campaign Summary',
    component: <SummaryContainer />,
    path: 'summary',
  },
  {
    label: 'Real-Time Optimization',
    component: <RealTimeOptimizationContainer />,
    path: 'real-time-optimization',
  },
];

export const TabView = () => {
  return <BaseTabView tabs={tabs} />;
};
